// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "textarea {\n  width: 120%;\n  height: 100px;\n  resize: none;\n  margin-right: 100px;\n}", "",{"version":3,"sources":["webpack://./src/pages/NewRec/newrec.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;AACJ","sourcesContent":["textarea {\n    width: 120%;\n    height: 100px;\n    resize: none;\n    margin-right: 100px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
